import type { ShipMode } from "./modes";

export type RoutePreference = { origin: string; mode: ShipMode };

const STORAGE_KEY = "pp-ship-route";

export function readRoutePreference(): RoutePreference | null {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "null") as Partial<RoutePreference> | null;
    if (!stored || typeof stored.origin !== "string") return null;
    if (stored.mode !== "air" && stored.mode !== "sea" && stored.mode !== "road") return null;
    return { origin: stored.origin, mode: stored.mode };
  } catch {
    return null;
  }
}

export function saveRoutePreference(preference: RoutePreference): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(preference));
  } catch {
    return;
  }
}
